export function sortAscending(propName) {
    return function (a, b) {
        if (a[propName] < b[propName])
            return -1;
        if (a[propName] > b[propName])
            return 1;
        return 0;
    };
};

export function sortDescending(propName) {
    return function (a, b) {
        if (a[propName] > b[propName])
            return -1;
        if (a[propName] < b[propName])
            return 1;
        return 0;
    };
};



